import { slide as Menu } from 'react-burger-menu';
import { Link } from 'react-router-dom';
import { Wrapper } from './Sidebar.styles';

const Sidebar = ({ setLogoutModalShow, setDeleteModalShow }) => {
  return (
    <Wrapper>
      <Menu>
        <h2 className='pb-1'>Trending</h2>
        <Link className='menu-item pb-2' to='best-seller'>
          <i class='bi bi-bar-chart-line-fill pe-2'></i> Best Seller
        </Link>
        <Link className='menu-item pb-2' to='discover'>
          <i class='bi bi-search pe-2'></i> Discover
        </Link>
        <h2 className='pb-1'>My Books</h2>
        <Link className='menu-item' to='reading'>
          <i class='bi bi-book pe-2'></i> reading
        </Link>
        <Link className='menu-item' to='plan-to-read'>
          <i class='bi bi-calendar-heart pe-2'></i> plan to read
        </Link>
        <Link className='menu-item pb-2' to='finished'>
          <i class='bi bi-bookmark-check pe-2'></i> finished
        </Link>
        <h2 className='pb-1'>My Account</h2>
        <button
          className='menu-item menu-button'
          onClick={() => setLogoutModalShow(true)}
        >
          <i class='bi bi-box-arrow-left pe-2'></i> Logout
        </button>
        <button
          className='menu-item menu-button'
          onClick={() => setDeleteModalShow(true)}
        >
          <i class='bi bi-person-x pe-2'></i> Delete Account
        </button>
      </Menu>
    </Wrapper>
  );
};

export default Sidebar;
